module.exports = __webpack_public_path__ + "static/media/高分三号卫星.549daa1f.png";